// attendanceUtils.js


export const handleGroupSelection = (direction, activegroupIndex, setActivegroupIndex, groups) => {
    if (direction === 'prev' && activegroupIndex > 0) {
        setActivegroupIndex(activegroupIndex - 1);
    } else if (direction === 'next' && activegroupIndex < groups.length - 1) {
        setActivegroupIndex(activegroupIndex + 1);
    } else if (direction === 'prev' && activegroupIndex === 0) {
        setActivegroupIndex(groups.length - 1);
    } else setActivegroupIndex(0);
};

export const handleNextSection = (activeSectionIndex, sections, setActiveSectionIndex) => {
    if (activeSectionIndex < sections.length - 1) {
        setActiveSectionIndex(activeSectionIndex + 1);
    }
};

export const handlePrevSection = (activeSectionIndex, setActiveSectionIndex) => {
    if (activeSectionIndex > 0) {
        setActiveSectionIndex(activeSectionIndex - 1);
    }
};

export const handleMonthChange = (direction, activeMonthIndex, setActiveMonthIndex, months) => {
    if (direction === 'prev' && activeMonthIndex > 0) {
        setActiveMonthIndex(activeMonthIndex - 1);
    } else if (direction === 'next' && activeMonthIndex < months.length - 1) {
        setActiveMonthIndex(activeMonthIndex + 1);
    } else if (direction === 'prev' && activeMonthIndex === 0) {
        setActiveMonthIndex(months.length - 1);
    } else setActiveMonthIndex(0);
};

export const handleYearChange = (direction, activeYearIndex, setActiveYearIndex, years) => {
    if (direction === 'prev' && activeYearIndex > 0) {
        setActiveYearIndex(activeYearIndex - 1);
    } else if (direction === 'next' && activeYearIndex < years.length - 1) {
        setActiveYearIndex(activeYearIndex + 1);
    } else if (direction === 'prev' && activeYearIndex === 0) {
        setActiveYearIndex(years.length - 1);
    } else setActiveYearIndex(0);
};

export const handleDaySelection = (index, setActiveDayIndex) => {
    setActiveDayIndex(index);
};



export const handleStudentSelection = (studentId, arr, setArr) => {
    setArr([...arr, studentId]);
};
